import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ColorPicker from '@/domain/termine/components/ColorPicker/ColorPicker';
import { FormValues } from '@/domain/termine/shared/types/CreateTermineInput';

export function ColorPickerFormField({
  form,
}: {
  form: UseFormReturn<FormValues>;
}) {
  const { t } = useTranslation();

  return (
    <FormField
      control={form.control}
      name="markierung"
      render={({ field }) => (
        <FormItem className="flex-1">
          <FormLabel>{t('domain.termine.sheet.fields.farbe')}</FormLabel>
          <ColorPicker value={field.value} onChange={field.onChange} />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
